import { useState } from 'react'
import { Link } from 'lucide-react'

const AnchorLink = ({ id, className = '' }) => {
  const [copied, setCopied] = useState(false)

  const handleClick = (e) => {
    e.preventDefault()
    const url = `${window.location.origin}${window.location.pathname}#${id}`
    navigator.clipboard.writeText(url).then(() => {
      window.history.replaceState(null, '', `#${id}`)
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    })
  }

  return (
    <a
      href={`#${id}`}
      onClick={handleClick}
      title={copied ? 'Link copied!' : 'Copy link'}
      className={[
        'inline-flex items-center justify-center w-5 h-5 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-150',
        copied
          ? 'text-green-500'
          : 'text-light-text-tertiary dark:text-dark-text-tertiary hover:text-primary-500',
        className
      ].join(' ')}
    >
      <Link className="w-3.5 h-3.5" />
    </a>
  )
}

export default AnchorLink
